<template>
    <div>
      <h2 class="c-heading__page u-mt3 u-pt5">{{ headerCaption }}</h2>
      <div>
        <div class="u-mt3" >
          <div class="u-mt4">
            <el-form inline>
              <el-form-item label="From" class="line-height-3"><el-date-picker v-model="range.from" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="range.to" type="date" format="MM/dd/yyyy" placeholder="Pick a date"></el-date-picker></el-form-item>
              <el-form-item label="Name" class="line-height-3">
                <el-select v-model="selectedUserName" filterable>
                  <el-option  :selected="selectedUser===user.id"
                              v-for="user in usersList"
                              :value="user.id"
                              :label="user.name"
                              :key="user.id"/>
                </el-select>
              </el-form-item>
              <el-form-item label="Action" class="line-height-3">
                <el-select v-model="selectedActionName" filterable>
                  <el-option  :selected="selectedAction===messageCode.key"
                              v-for="messageCode in messageCodesListWithAll"
                              :label="messageCode.value"
                              :value="messageCode.key"
                              :key="messageCode.key"/>
                </el-select>
              </el-form-item>
              <el-form-item><el-button @click="loadPage(1)" icon="el-icon-search">Filter</el-button></el-form-item>
              <el-button v-if="range.from !== '' || range.to !== '' || this.selectedUser !== -1 || this.selectedAction !== 'all_actions'" @click="clearFilter">Clear Filter</el-button>
            </el-form>
          </div>
          <div class="u-mt5 u-mb2 download-actions">
            <el-checkbox v-if="isSuperUser" @change="loadPage(1)" v-model="showCarrierOnly" class="">Only Show Carrier Viewable Actions</el-checkbox>
            <el-button @click="downloadInsuredActionsListXls">Download User Actions</el-button>
          </div>
          <el-table v-loading="loading" @sort-change="sortChange" ref="actionsTable" class="u-mt3 actions-table" :data="items" style="width: max-content" :row-class-name="getStatusClassName">
            <el-table-column label="Action">
              <template slot-scope="scope">
                {{scope.row.action_name}}
              </template>
            </el-table-column>"
            <el-table-column columnKey="user__username" prop="user_name" label="User Name" width="300" sortable></el-table-column>
            <el-table-column columnKey="received_at" label="Date/Timestamp" width="300" sortable>
              <template slot-scope="scope">
                {{ fixedTimestamp(scope.row.received_at) }}
              </template>
            </el-table-column>
            <el-table-column columnKey="name" label="Name" width="300">
              <template slot-scope="scope">
                {{ getInsured(scope.row)}}
              </template>  
            </el-table-column>
            <el-table-column columnKey="name" label="Company" width="300" v-if="isGlobalActionsMode">
              <template slot-scope="scope">
                {{ scope.row.company ? scope.row.company.name : 'N/A'}}
              </template>
            </el-table-column>
            <el-table-column type="expand" sortable>
              <template slot-scope="scope">
                <ba-action-detail :details="scope.row"></ba-action-detail>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="u-mt4" :layout="paginationLayout"
                         :total="total" :page-size="perPage"
                         :current-page="currentPage" @current-change="loadPage">
          </el-pagination>
        </div>
      </div>
    </div>
</template>

<script>

import ElButton from 'element-ui/packages/button/src/button'
import BaActionDetail from '@/modules/insuredactions/insuredactions-details.component.vue'
import {mapState} from 'vuex'
import axios from 'axios'
import config from '@/config'
import _ from 'lodash'

import * as moment from 'moment'

export default {
  props: ['companyId', 'headerCaption'],
  components: {
    ElButton,
    BaActionDetail,
  },
  name: 'ba-insured-actions-component',
  data () {
    return {
      range: {
        from: '',
        to: '',
      },
      items: [],
      usersListBriteApps: [],
      selectedUser: -1,
      selectedAction: 'all_actions',
      messageCodesList: [],
      loading: true,
      total: 0,
      perPage: 20,
      currentPage: 1,
      numPages: 0,
      table: null,
      sort: null,
      showCarrierOnly: false
    }
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  computed: {
    ...mapState('shared', ['user']),
    paginationLayout () {
      let moreThan15Pages = this.numPages > 15
      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },
    isGlobalActionsMode () {
      return !this.companyId
    },
    isSuperUser () {
      return ((this.user !== undefined) && (this.user != null)) ? this.user.is_superuser : false
    },
    messageCodesListWithAll () {
      return [{key: 'all_actions', value: 'All'}].concat(this.messageCodesList)
    },
    selectedActionName: {
      get: function () {
        let action = _.find(this.messageCodesListWithAll, actionObj => {
          return actionObj.key === this.selectedAction
        })
        if (action == null) {
          return 'All'
        }
        return action.value
      },
      set: function (newValue) {
        this.selectedAction = newValue
      }
    },
    usersList () {
      return [{id: -1, name: 'All'}].concat(this.usersListBriteApps)
    },
    selectedUserName: {
      get: function () {
        let user = _.find(this.usersList, user => {
          return user.id === this.selectedUser
        })
        return user.name
      },
      set: function (newValue) {
        this.selectedUser = newValue
      }
    }
  },
  methods: {
    loadInitial () {
      this.loadPage(1)
    },
    getStatusClassName ({row, rowIndex}) {
      if (!this.isSuperUser || this.showCarrierOnly) return ''
      return row.extra_vars.impersonator_id ? 'pending-row' : ''
    },
    getParamsForPage (page) {
      let params = {
        page_size: this.perPage,
        page: page,
        from_date: this.$moment(this.range.from).format('MM-DD-YYYY'),
        to_date: this.$moment(this.range.to).format('MM-DD-YYYY'),
        sort: this.sort,
        show_carrier_only: this.showCarrierOnly,
      }
      if (this.selectedUser !== -1) {
        params.user = this.selectedUser
      }
      if (this.selectedAction !== 'all_actions') {
        params.message_code = this.selectedAction
      }
      return params
    },
    async loadPage (page) {
      this.loading = true
      if (this.table && this.sort === undefined) {
        this.table.clearSort()
      }

      try {
        let result
        if (this.isGlobalActionsMode) {
          result = await axios.post(`${config.url}/get-global-insured-actions-list/`, this.getParamsForPage(page))
        } else {
          result = await axios.post(`${config.url}/company/${this.companyId}/get_insured_actions_list/`, this.getParamsForPage(page))
        }

        this.currentPage = page
        this.items = result.data.data.search_result.items
        this.total = result.data.data.search_result.total
        this.perPage = result.data.data.search_result.page_size
        this.numPages = result.data.data.search_result.num_pages
        this.usersListBriteApps = result.data.data.users
        this.messageCodesList = result.data.data.message_codes
      } finally {
        this.loading = false
      }
    },
    encodeQueryData (data) {
      let ret = []
      for (let d in data) {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
      }
      return ret.join('&')
    },
    downloadInsuredActionsListXls () {
      let params = this.getParamsForPage(0)
      delete params['page']
      delete params['page_size']
      delete params['sort']
      params['token'] = localStorage.carrierToken
      let url = config.url + '/company/' + this.companyId + '/get_insured_actions_list_xls/?' + this.encodeQueryData(params)
      window.open(url, '_blank')
    },
    fixedTimestamp (timestamp) {
      return moment(new Date(timestamp)).format('MM/DD/YYYY hh:mm:ss A')
    },
    getInsured (row) {
      return row.ignore_insured ? 'N/A' : row.name
    },
    clearFilter () {
      this.range.from = ''
      this.range.to = ''
      this.selectedUser = -1
      this.selectedAction = 'all_actions'
      return this.loadPage(1)
    },
    sortChange (sortProperties) {
      this.table = this.$refs['actionsTable']
      this.sort = null
      if (sortProperties.column != null) {
        this.sort = {
          order: sortProperties.order,
          column: sortProperties.column.columnKey
        }
      }
      this.loadPage(1)
    },
  },
}
</script>

<style scoped>
  .actions-table {
    width: auto !important;
  }
  .download-actions {
    overflow: hidden;
    margin-bottom: -20px;
  }  
  .download-actions > button {
    float: right;
  }  
  .line-height-3 {
    line-height: 2em;
  }
</style>


